import { render, staticRenderFns } from "./FootprintBungePorto.vue?vue&type=template&id=4a8717a4&lang=pug"
import script from "./FootprintBungePorto.vue?vue&type=script&lang=js"
export * from "./FootprintBungePorto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports